interface PushNotificationPreviewProps {
  title: string;
  body: string;
}

// iOS: title ~50 chars, body ~178 chars (4 lines before truncation)
// Android: title ~65 chars, body ~240 chars
// Using iOS as the stricter limit
const TITLE_MAX_LENGTH = 50;
const BODY_MAX_LENGTH = 178;

export { TITLE_MAX_LENGTH, BODY_MAX_LENGTH };

export const PushNotificationPreview = ({ title, body }: PushNotificationPreviewProps) => {
  const displayTitle = title || 'Notification Title';
  const displayBody = body || 'Notification body text will appear here...';

  return (
    <div className="d-flex flex-column align-items-center">
      <h6 className="text-muted mb-3">Push Notification Preview</h6>

      {/* Notification card */}
      <div
        style={{
          width: '370px',
          backgroundColor: 'rgba(245, 245, 247, 0.95)',
          backdropFilter: 'blur(40px)',
          borderRadius: '16px',
          padding: '14px',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.12)',
          fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", sans-serif',
        }}
      >
        <div className="d-flex" style={{ gap: '12px' }}>
          {/* App icon */}
          <div
            style={{
              width: '44px',
              height: '44px',
              minWidth: '44px',
              borderRadius: '10px',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
              marginTop: '2px',
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="#333" strokeWidth="1.4" />
              <ellipse cx="12" cy="12" rx="3.5" ry="9" stroke="#333" strokeWidth="1.4" />
              <line x1="3" y1="12" x2="21" y2="12" stroke="#333" strokeWidth="1.4" />
            </svg>
          </div>

          {/* Content */}
          <div style={{ flex: 1, minWidth: 0 }}>
            {/* Title line with timestamp */}
            <div className="d-flex align-items-baseline" style={{ gap: '8px', marginBottom: '2px' }}>
              <div
                style={{
                  fontSize: '15px',
                  fontWeight: 600,
                  color: '#1c1c1e',
                  lineHeight: '1.3',
                  flex: 1,
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {displayTitle}
              </div>
              <span
                style={{
                  fontSize: '13px',
                  color: '#8e8e93',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                }}
              >
                now
              </span>
            </div>

            {/* Body - narrower width, not extending under timestamp */}
            <div
              style={{
                fontSize: '15px',
                color: '#3a3a3c',
                lineHeight: '1.4',
                display: '-webkit-box',
                WebkitLineClamp: 4,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                paddingRight: '48px',
              }}
            >
              {displayBody}
            </div>
          </div>
        </div>
      </div>

      {/* Character count info */}
      <div className="mt-3 text-muted" style={{ fontSize: '13px', width: '370px' }}>
        <div className="d-flex justify-content-between">
          <span>
            Title:{' '}
            <strong style={{ color: title.length > TITLE_MAX_LENGTH ? '#dc3545' : undefined }}>
              {title.length}
            </strong>
            /{TITLE_MAX_LENGTH}
          </span>
          <span>
            Body:{' '}
            <strong style={{ color: body.length > BODY_MAX_LENGTH ? '#dc3545' : undefined }}>
              {body.length}
            </strong>
            /{BODY_MAX_LENGTH}
          </span>
        </div>
        {(title.length > TITLE_MAX_LENGTH || body.length > BODY_MAX_LENGTH) && (
          <div className="text-danger mt-1" style={{ fontSize: '12px' }}>
            Text may be truncated on some devices.
          </div>
        )}
        <div className="mt-1" style={{ fontSize: '11px', color: '#adb5bd' }}>
          iOS: title ~50, body ~178 chars / Android: title ~65, body ~240 chars
        </div>
      </div>
    </div>
  );
};
